import React, { useCallback, useEffect, useState } from "react";
import { connect } from "react-redux";
import PropTypes from "prop-types";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faBarcode } from "@fortawesome/free-solid-svg-icons";
import { BANK_DOCUMENT_SEND_SUCCESS, sendBankDocument } from "../../../../store/actions/customer-actions";
import { GET_OR_CREATE_BILL_SUCCESS, getOrCreateBill, requestBillBarCode } from "../../../../store/actions/loan-actions";
import { ModalPaymentContainer } from "./modal-payment-container";
import { CopyHelper } from '../../../../utils/helper/copy-helper';
import { CheckIcon, SpinnerIcon } from "../icons";

function ModalSlipOptions(props) {
  const { show, onClose, installment, loanId, sendToEmail, getOrCreateBill, onModalAlertChange, device } = props;

  const installmentNumber = installment?.number;
  const billId = installment?.bill?.id;

  const [sendingEmail, setSendingEmail] = useState({ inProgress: false, success: false, error: '' });
  const [copyingBarCode, setCopyingBarCode] = useState({ inProgress: false, success: false, error: '' });
  const [loading, setLoading] = useState(false);
  const [actualBillId, setActualBillId] = useState(billId);

  const copyBillBarCode = async () => {
    setSendingEmail({ inProgress: false, success: false, error: '' });
    setCopyingBarCode({ inProgress: true, success: false, error: '' });

    // TODO: Check if bill is boleto. If not, create a boleto bill and copy the bar code. Do it in backend.
    const response = await props.requestBillBarCode(installment.number, props.device);

    if (response?.payload?.execution) {
      // Request successful.
      const barCode = response.payload.execution?.additionalInformation?.slipBarCode;

      if (barCode) {
        // Slip code exists.
        CopyHelper.copyToClipboard(barCode);
        setCopyingBarCode({ inProgress: false, success: true, error: '' });
        // Wait 2 secs and remove success icon.
        setTimeout(() => {
          setCopyingBarCode({ inProgress: false, success: false, error: '' });
        }, 2000);
      } else {
        // Slip code does not exist.
        // TODO: Make the error more specific.
        setCopyingBarCode({ inProgress: false, success: false, error: 'Não foi possível copiar o código do boleto.' });
      }
    } else {
      // Request failed.
      // TODO: Make the error more specific.
      setCopyingBarCode({ inProgress: false, success: false, error: 'Não foi possível copiar o código do boleto.' });
    }
  };

  const sendBillByEmail = async () => {
    setSendingEmail({ inProgress: true, success: false, error: '' });
    setCopyingBarCode({ inProgress: false, success: false, error: '' });

    const response = await sendToEmail(loanId, installment.number, installment.owedAmount, props.device);
    // If request is successful.
    if (response.type === BANK_DOCUMENT_SEND_SUCCESS) {
      setSendingEmail({ inProgress: false, success: true, error: '' });
      // Wait 2 secs and remove success icon.
      setTimeout(() => {
        setSendingEmail({ inProgress: false, success: false, error: '' });
      }, 2000);
    }
    // If request failed.
    else {
      setSendingEmail({ inProgress: false, success: false, error: 'Não foi possível enviar o boleto por email.' });
    }
  };

  const getBill = async () => {
    setLoading(true);
    const response = await getOrCreateBill('SLIP', device, actualBillId, [installmentNumber]);
    if (response.type === GET_OR_CREATE_BILL_SUCCESS) {
      const bill = response.payload;
      setActualBillId(bill?.id);
    }
    setLoading(false);
  };

  const getBillCallback = useCallback(getBill, [actualBillId, device, installmentNumber, getOrCreateBill]);

  useEffect(() => {
    if (show) {
      (async () => {
        await getBillCallback();
      })();
    }
    return () => {
    };
  }, [show, getBillCallback]);

  return (
    <>
      {show &&
        <ModalPaymentContainer
          headerTitle="Opções do boleto"
          onClose={onClose}
          icon={<FontAwesomeIcon icon={faBarcode} size="4x" />}
        >
          <div className="modal-slip-options">
            {!loading ? <>
              <div className="modal-slip-option">
                <button onClick={sendBillByEmail}>Enviar para o e-mail {sendingEmail.inProgress && <SpinnerIcon className="loading" />}
                  {sendingEmail.success && <CheckIcon style={{ color: '#00BA88', width: '16px', height: '16px' }} className="" />}</button>
                {sendingEmail.error && <span style={{ color: '#FF4F50', marginTop: '12px', fontWeight: 'normal' }}>{sendingEmail.error}</span>}
              </div>
              <div className="modal-slip-option">
                <a target="_blank" href={`/api/loan/current/re-payments/supersim-pagamento.pdf?installmentNumber=${installment.number}`}>
                  <button
                    onClick={() => onModalAlertChange(true, "O boleto foi baixado ou aberto em outra aba. Verifique sua pasta de downloads.", "Atenção")}>
                    Baixar boleto
                  </button>
                </a>
              </div>
              <div className="modal-slip-option">
                <button onClick={copyBillBarCode}>Copiar código de barras {copyingBarCode.inProgress && <SpinnerIcon className="loading" />}
                  {copyingBarCode.success && <CheckIcon style={{ color: '#00BA88', width: '16px', height: '16px' }} className="" />}</button>
                {copyingBarCode.error && <span style={{ color: '#FF4F50', marginTop: '12px', fontWeight: 'normal' }}>{copyingBarCode.error}</span>}
              </div>
            </>
            :
            <div className="modal-slip-options-loading"><SpinnerIcon className="loading" /></div>
            }
          </div>
        </ModalPaymentContainer>
      }
    </>
  );
}

ModalSlipOptions.propTypes = {
  show: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
  installment: PropTypes.object.isRequired,
  loanId: PropTypes.number.isRequired,
};

ModalSlipOptions.defaultProps = {
  show: false,
};

const mapStateToProps = (state) => ({
  device: state.customer.device,
});

const mapDispatchToProps = (dispatch) => ({
  getOrCreateBill: (billingMethod, device, billId, installmentsNumbers) => dispatch(getOrCreateBill(billingMethod, device, billId, installmentsNumbers)),
  sendToEmail: (loanId, installmentNumber, amount, device) => dispatch(sendBankDocument(installmentNumber, amount, device)),
  requestBillBarCode: (installmentNumber, device) => dispatch(requestBillBarCode(installmentNumber, device)),
});

export default connect(mapStateToProps, mapDispatchToProps)(ModalSlipOptions);
